var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSent)?_c('notification-sent-modal'):_c('v-btn',{staticClass:"ml-2",attrs:{"color":"success","type":"submit","loading":_vm.loading}},[_vm._v(" Salvar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }